import {
  NavigateFunction,
  useLocation,
  useOutletContext,
} from 'react-router-dom'
import { EndUserCampaign } from '../../../../server/generated/prisma'
import { useTranslation } from 'react-i18next'
import { TFunction } from 'i18next'
import { Campaign } from '@/types/campaign'

type PartialEndUser = Partial<EndUserCampaign>

type ECComponentType = {
  campaign: Campaign
  endUser: PartialEndUser
  t: TFunction<'translation', undefined>
  pathname: string
  id?: string
  navigate: NavigateFunction
  onSubmit(questionnaire: unknown): void
  error: string
  setError(error: string): void
  integrations: { features: Record<string, unknown> }[]
}
export default function Preview({
  Component,
}: {
  Component: any
}) {
  const { t } = useTranslation()
  const location = useLocation()
  const { pathname } = location
  const { campaign, endUser, error, setError } =
    useOutletContext<ECComponentType>()

  return (
    <Component
      campaign={campaign}
      endUser={endUser}
      t={t}
      pathname={pathname}
      navigate={() => {}}
      onSubmit={() => {}}
      error={error}
      setError={setError}
      integrations={[]}
    />
  )
}
